<ng-template
  #overlay="cdkConnectedOverlay"
  cdkConnectedOverlay
  cdkConnectedOverlayPanelClass="valg-overflow-menu-overlay"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayPositions]="overlayConnectedPositions"
  (detach)="onClose()"
>
  <div class="valg-overflow-menu" [cdkTrapFocus]="isOpen">
    <ng-content select="button[valgButton]"></ng-content>
  </div>
</ng-template>